import { Navigate } from 'react-router-dom';
import SplashScreen from '../../view/components/SplashScreen';
import { useAuth } from '../hooks/useAuth';
import { pagePath } from '../utils/consts/pagePath';

interface IAuthGuardProps {
  isPrivate: boolean;
  children?: React.ReactNode;
}

export function AuthGuard({ isPrivate, children }: IAuthGuardProps) {
  const { isAuthenticated, isAuthLoading, isAuthChecking } = useAuth();

  if (isAuthLoading || isAuthChecking) {
    return <SplashScreen isLoading />;
  }

  if (isAuthenticated === false && isPrivate) {
    return <Navigate to={pagePath.login} replace />;
  }

  if (isAuthenticated === true && !isPrivate) {
    return <Navigate to={pagePath.home} replace />;
  }

  return children;
}
